export const suggestionItemStyle = (theme) => ({
  suggestionItem: {
    width: '100%',
    background: ({ selected }) => selected ? theme.primary[0] : theme.neutral[400]
  }
})
